<LayoutMain>
  <template #header>
    <PageHeader :title="t('privacyPolicy.title')">
      <template #icon>
        <span class="mr-2">🔐</span>
      </template>
    </PageHeader>
  </template>

  <div class="space-y-6 max-w-3xl mx-auto">
    <p class="text-sm text-gray-600 italic">{{ t('privacyPolicy.lastUpdated') }}</p>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.infoWeCollectTitle') }}</h2>
    <ul class="list-disc list-inside space-y-1">
      <li>{{ t('privacyPolicy.infoWeCollectItem1') }}</li>
      <li>{{ t('privacyPolicy.infoWeCollectItem2') }}</li>
      <li>{{ t('privacyPolicy.infoWeCollectItem3') }}</li>
      <li>{{ t('privacyPolicy.infoWeCollectItem4') }}</li>
    </ul>
    <p v-html="t('privacyPolicy.infoWeDontCollect')"></p>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.howWeUseDataTitle') }}</h2>
    <ul class="list-disc list-inside space-y-1">
      <li>{{ t('privacyPolicy.howWeUseDataItem1') }}</li>
      <li>{{ t('privacyPolicy.howWeUseDataItem2') }}</li>
      <li>{{ t('privacyPolicy.howWeUseDataItem3') }}</li>
      <li>{{ t('privacyPolicy.howWeUseDataItem4') }}</li>
    </ul>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.dataSharingTitle') }}</h2>
    <p>{{ t('privacyPolicy.dataSharingText') }}</p>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.dataRetentionTitle') }}</h2>
    <ul class="list-disc list-inside space-y-1">
      <li>{{ t('privacyPolicy.dataRetentionItem1') }}</li>
      <li>{{ t('privacyPolicy.dataRetentionItem2') }}</li>
      <li>{{ t('privacyPolicy.dataRetentionItem3') }}</li>
    </ul>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.securityTitle') }}</h2>
    <ul class="list-disc list-inside space-y-1">
      <li>{{ t('privacyPolicy.securityItem1') }}</li>
      <li>{{ t('privacyPolicy.securityItem2') }}</li>
    </ul>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.yourRightsTitle') }}</h2>
    <p v-html="t('privacyPolicy.yourRightsText')"></p>

    <h2 class="font-semibold text-lg">{{ t('privacyPolicy.policyUpdatesTitle') }}</h2>
    <p>{{ t('privacyPolicy.policyUpdatesText') }}</p>
  </div>
</LayoutMain>
